module.exports = __webpack_public_path__ + "static/img/1.5b8a5f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1.png
// module id = 187
// module chunks = 1